﻿﻿export interface IContactPositionForList {
    id: number;
    description: string;
}
